<template>
  <ul
    v-if="templates"
    class="activity-templates-list"
    :class="{
      'activity-templates-list--grid': layout === 'grid',
      'activity-templates-list--list': layout === 'list',
    }"
  >
    <li
      v-for="template in templates"
      :key="template.id"
      class="activity-templates-list__item-wrapper"
    >
      <RouterLink
        class="activity-templates-list__item"
        :to="{ query: { ...$route.query, id: template.id } }"
      >
        <div
          v-if="layout === 'list'"
          class="activity-templates-list__type"
        >
          <!-- This is the asset type: "Slideshow" or "Board" -->
          {{ $t(template.type) }}
        </div>
        <div class="activity-templates-list__title">
          {{ template.decodedTitle }}
        </div>
        <div class="activity-templates-list__skills">
          <span>
            {{ $t('Skills:') }}
          </span>
          {{ template.skills.join(', ') }}
        </div>
      </RouterLink>
    </li>

    <!-- Spacers -->
    <li
      class="activity-templates-list__item-wrapper activity-templates-list__item-wrapper--invisible"
      aria-hidden="true"
    />
    <li
      class="activity-templates-list__item-wrapper activity-templates-list__item-wrapper--invisible"
      aria-hidden="true"
    />
    <li
      class="activity-templates-list__item-wrapper activity-templates-list__item-wrapper--invisible"
      aria-hidden="true"
    />
  </ul>
</template>

<script>
export default {
  name: 'ActivityTemplatesList',
  props: {
    layout: {
      type: String,
      default: 'grid', // out of ['grid', 'list']
    },
    templates: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style lang="stylus">
.activity-templates-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;

  &__item {
    background-color: $nebula-color-white;
    border: none;
    border-radius: $nebula-space-3x;
    box-shadow: $nebula-shadow-400;
    display: block;
    height: 100%;
    margin: 0;
    overflow: hidden;
    padding: $nebula-space-2x $nebula-space-3x;
    text-align: start;
    text-decoration: none;
    width: 100%;

    &:hover, &:focus {
      .activity-templates-list__title {
        color: $nebula-color-interactive-blue-400;
      }
    }
  }

  &__type {
    nebula-text-body-2();
    color: $nebula-color-interface-blue-500;
    font-weight: bold;
    margin-bottom: $nebula-space-half;
    text-transform: uppercase;
  }

  &__title {
    nebula-text-h6();
    margin-bottom: $nebula-space-1x;
  }

  &__skills {
    nebula-text-body-1();

    span {
      font-weight: bold;
    }
  }

  &--grid {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    .activity-templates-list__item-wrapper {
      margin: 0 0 $nebula-space-2x 0;
      width: 100%;

      &--invisible {
        margin: 0;
      }
    }

    @media screen and (min-width: $comet-breakpoints-tablet-narrow-portrait) {
      .activity-templates-list__item-wrapper {
        width: "calc(50% - %s * 1/2)" % $nebula-space-2x;
      }
    }

    @media screen and (min-width: $comet-breakpoints-tablet-portrait) {
      .activity-templates-list__item-wrapper {
        width: "calc(33.3% - %s * 2/3)" % $nebula-space-2x;
      }
    }

    @media screen and (min-width: $comet-breakpoints-desktop-wide) {
      .activity-templates-list__item-wrapper {
        width: "calc(25% - %s * 3/4)" % $nebula-space-2x;
      }
    }
  }

  &--list {
    flex-direction: column;

    .activity-templates-list__item-wrapper {
      margin-bottom: $nebula-space-2x;
      width: 100%;
    }

    .activity-templates-list__skills {
      nebula-text-body-2();
    }
  }
}
</style>
